<div class="other-claim-chart-layout" [class.other-claim-chart-layout--empty]="!hasData">
  @if (hasData && legendItems.length) {
  <div class="other-claim-chart__legend">
    <div class="other-claim-chart__legend-table">
      <div class="other-claim-chart__legend-header">
        <span>{{ 'dashboard.other_claims_legend.claimType' | translate }}</span>
        <span class="other-claim-chart__legend-cell--numeric">{{ 'dashboard.other_claims_legend.amount' | translate }}</span>
        <span class="other-claim-chart__legend-cell--numeric">{{ 'dashboard.other_claims_legend.total' | translate }}</span>
      </div>
      @for (item of legendItems; track item.claimTypeValue) {
      <button type="button" class="other-claim-chart__legend-row"
        [matTooltip]="getLegendItemTooltip(item.label)"
        (click)="onLegendItemClick(item.claimTypeValue)">
        <span class="other-claim-chart__legend-type">
          <span class="other-claim-chart__legend-marker" [style.backgroundColor]="item.color"></span>
          <span class="other-claim-chart__legend-label">{{ truncateLegendLabel(item.label) }}</span>
        </span>
        <span class="other-claim-chart__legend-amount other-claim-chart__legend-cell--numeric">
          {{ item.amount | currency:'USD':'symbol':'1.0-0' }}
        </span>
        <span class="other-claim-chart__legend-total other-claim-chart__legend-cell--numeric">
          {{ item.total }}
        </span>
      </button>
      }
    </div>
  </div>
  }

  @if (hasData) {
  <div class="other-claim-chart__plot">
    <apx-chart #chart [series]="chartOptions.series!" [chart]="chartOptions.chart!"
      [plotOptions]="chartOptions.plotOptions!" [labels]="chartOptions.labels!" [legend]="chartOptions.legend!"
      [stroke]="chartOptions.stroke!" [colors]="chartOptions.colors!" [responsive]="chartOptions.responsive!"
      [tooltip]="chartOptions.tooltip!" [dataLabels]="chartOptions.dataLabels!">
    </apx-chart>
  </div>
  } @else {
  <app-dashboard-chart-empty-state messageKey="dashboard.no_other_claims" />
  }
</div>
